import { Component } from 'react';

// Route-level error boundary — a render crash in a child (e.g. an unguarded
// fetch result) shows a minimal fallback instead of white-screening the app.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', this.props.label || 'route', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-xl mx-auto mt-16 bg-white border border-amber-200 rounded-xl shadow-sm p-8 text-center">
          <div className="text-3xl mb-3">⚠️</div>
          <h2 className="font-semibold text-gray-900 mb-2">Couldn't load part of this ticket</h2>
          <p className="text-sm text-gray-500 mb-5">
            Something on this page failed to render. Your session is still active.
          </p>
          <div className="flex justify-center gap-3">
            <button
              onClick={() => this.setState({ hasError: false })}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
            >Try again</button>
            <a
              href="/tickets"
              className="px-4 py-2 border border-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50"
            >Back to tickets</a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
